import { render } from "./CommonConfigSetting.vue?vue&type=template&id=52c9ec89"
import script from "./CommonConfigSetting.vue?vue&type=script&lang=js"
export * from "./CommonConfigSetting.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__